<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="page">
    <section class="hero">
      <div class="hero-content">
        <h1>量化深研平台｜AI 驱动的 A 股全链路量化研究平台</h1>
        <p>从因子挖掘、策略验证到模拟推演，一站式完成量化投研闭环，<br>让策略想法快速落地可验证。</p>
      </div>
    </section>

    <section class="intro">
      <h2>专为投研人员打造的深度量化研究底座</h2>
      <p>量化深研平台聚焦 A 股市场，整合多维度行情、基本面、情绪与因子数据。打通想法构思、因子检验、策略回测、仿真推演全流程，内置 AI 投研助手，降低量化研究门槛。</p>
      <div class="features">
        <div v-for="x in features" :key="x" class="feature-item">{{x}}</div>
      </div>
    </section>

    <section class="modules">
      <article v-for="m in modules" :key="m[0]" class="module-card">
        <div class="module-icon"></div>
        <h3>{{m[0]}}</h3>
        <p>{{m[1]}}</p>
      </article>
    </section>

    <section class="data">
      <h2>平台数据</h2>
      <div class="data-stats">
        <div class="stat-item">
          <span class="stat-number">180+</span>
          <span class="stat-label">覆盖全分类量化因子库</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">7</span>
          <span class="stat-label">大量化研究核心模块</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">全A</span>
          <span class="stat-label">沪深北交易所市场全覆盖</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">毫秒级</span>
          <span class="stat-label">回测与流式验证算力支撑</span>
        </div>
      </div>
    </section>

    <footer>
      <strong>超天才量化开源技术服务</strong>
      <p>开启你的深度量化研究之旅</p>
      <div class="footer-links">
        <a href="#">用户协议</a>
        <span>|</span>
        <a href="#">隐私协议</a>
        <span>|</span>
        <a href="#">关于我们</a>
      </div>
      <div class="footer-copyright">京ICP备09005826号-5</div>
    </footer>
  </div>
</template>

<script setup>
const features = [
  '海量内置因子库',
  'AI 辅助策略生成',
  '流式迭代验证引擎',
  '全维度风险归因',
  '可溯源可复现研究结果'
]

const modules = [
  ['行情洞察', '全市场多维透视，读懂市场风格与资金轮动'],
  ['AI 选股', '大模型 + 多因子融合，智能挖掘潜在标的池'],
  ['模拟推演', '贴近实盘规则，仿真运行你的投资策略'],
  ['AI 择时', 'AI 模型研判大盘、行业拐点，输出择时信号'],
  ['流式验证', '增量式因子与策略检验，高效迭代策略想法'],
  ['智能研究', 'AI 辅助因子挖掘、归因分析、生成研究报告']
]
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.page {
  font-family: "Microsoft YaHei", Arial, sans-serif;
  color: #171717;
  padding-top: 72px;
  min-height: 100vh;
  background: #f8f9fa;
}

.hero {
  height: 580px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10%;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></svg>');
  background-size: 100px;
  opacity: 0.5;
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: white;
  max-width: 900px;
}

.hero h1 {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 24px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.hero p {
  font-size: 18px;
  line-height: 1.8;
  opacity: 0.95;
}

.intro {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 24px;
}

.intro h2 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.intro > p {
  text-align: center;
  font-size: 16px;
  line-height: 1.9;
  color: #595959;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.feature-item {
  background: white;
  border: 1px solid #e8e8e8;
  padding: 32px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: default;
}

.feature-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-color: #1890ff;
}

.modules {
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 24px 100px;
}

.modules {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}

.module-card {
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.module-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
}

.module-icon {
  height: 180px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  transition: all 0.3s ease;
}

.module-card:hover .module-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.module-card h3 {
  margin: 20px 24px 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.module-card p {
  margin: 0 24px 24px;
  font-size: 14px;
  line-height: 1.8;
  color: #595959;
}

.data {
  background: white;
  padding: 100px 24px;
}

.data h2 {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 50px;
  color: #1a1a1a;
}

.data-stats {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
}

.stat-item {
  text-align: center;
  padding: 30px;
  border-radius: 12px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.stat-number {
  display: block;
  font-size: 48px;
  font-weight: 700;
  color: #1890ff;
  margin-bottom: 12px;
}

.stat-label {
  display: block;
  font-size: 15px;
  color: #595959;
}

footer {
  background: #1a1a1a;
  color: white;
  padding: 80px 10%;
  text-align: center;
}

footer strong {
  display: block;
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: 600;
}

footer p {
  font-size: 16px;
  opacity: 0.8;
  margin-bottom: 32px;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  font-size: 14px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: white;
}

.footer-links span {
  opacity: 0.4;
}
.footer-copyright{
  margin-top: 20px;
  font-size: 18px;

}
@media (max-width: 768px) {
  .hero {
    height: 480px;
    padding: 0 24px;
  }

  .hero h1 {
    font-size: 28px;
  }

  .hero p {
    font-size: 16px;
  }

  .intro h2,
  .data h2 {
    font-size: 24px;
  }

  .stat-number {
    font-size: 36px;
  }

  footer strong {
    font-size: 24px;
  }
}
</style>



